import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiProductionKind, ApiProductionKindFilter } from "./types";

interface ProductionKindsListResponse {
    outData: ApiProductionKind[];
}

/**
 * Транспортный слой OMP — виды продукции УП.
 */
export const productionKindsApi = {
    /**
     * Загружает виды продукции/производства для цеховых операций.
     * Запрос уходит в endpoint `stock/productionKinds.loadByFilter`.
     */
    load: async (params: { flt?: ApiProductionKindFilter }, config?: RequestConfig): Promise<ApiProductionKind[]> => {
        const data = await ompApiClient.postOmega<ProductionKindsListResponse>(
            "stock/productionKinds.loadByFilter",
            params,
            config,
        );
        return data.outData;
    },
} as const;
